goog.provide("shadow.js.shim.module$print_js");
goog.provide("module$shadow_js_shim_module$print_js");
shadow.js.shim.module$print_js = shadow.js.nativeProvides["print-js"] = shadow$bridge("print-js");
module$shadow_js_shim_module$print_js.default = shadow.js.shim.module$print_js;
